import {
  CLEAR_FETCH_EVENT_PERMALINK_EM_STATES,
  FETCH_EVENT_PERMALINK_EM_FAILURE,
  FETCH_EVENT_PERMALINK_EM_SUCCESS,
  REQUEST_FETCH_EVENT_PERMALINK_EM,
} from "./eventPermalink.types";

let initialState = {
  reload: false,
  response: {},
  error: null,
  loading: false,
};

const eventPermalinkEmReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FETCH_EVENT_PERMALINK_EM:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_EVENT_PERMALINK_EM_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        reload: false,
      };

    case FETCH_EVENT_PERMALINK_EM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        reload: false,
      };

    case CLEAR_FETCH_EVENT_PERMALINK_EM_STATES:
      return {
        ...state,
        loading: false,
        response: {},
        error: null,
        reload: false,
      };

    default:
      return state;
  }
};

export default eventPermalinkEmReducer;
